import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ title, links }) {
        return (
            <more-scopes-menu>
                <h1 class='more-scopes-header'>{title}</h1>
                <ul class='more-scopes-links'>
                    {links.map(link => {
                        this.trackImpression(link.title);

                        return (
                            <li class='more-scopes-list-item'>
                                <a
                                  class='more-scopes-list-link text-center'
                                  href={link.url}
                                  onClick={this.trackClick}
                                >
                                    {link.title}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </more-scopes-menu>
        );
    }

    trackImpression = (text) => {
        const action = this.props.logged_in ? 'LI Impression' : 'LO Impression';
        const label = `${this.props.page}:${text}`;

        this.props.trackEvent(['Horoscope Dropdown', action, label]);
    }

    trackClick = (e) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        const label = `${this.props.page}:${e.target.text}`;

        this.props.trackEvent(['Horoscope Dropdown', action, label]);
    }
}

const mapStateToProps = (state) => ({
    title: state['more-scopes-menu'] && state['more-scopes-menu'].title,
    links: state['more-scopes-menu'] && state['more-scopes-menu'].links,
    page: state['more-scopes-menu'] && state['more-scopes-menu'].page,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/more-scopes-menu.js